import { requests } from "../../../utils/api/api.service";
import { ADMIN_COMPANY } from "../../../utils/api/endpoints";

export const CompanyService = {
  getCompanyDetails: () => requests.get(ADMIN_COMPANY),
};
